import { RawDraftContentState } from 'draft-js';
import { TagLang, TagType } from '../../__generated__/queries-web';
import { allowedTagTypes } from '../TagList/utils';

const MIN_ALPHANUMERIC_CHARACTERS = 2;
const MAX_TITLE_LENGTH = 255;

export const isAllowedTagType = (value: string): value is TagType =>
  allowedTagTypes.some((tagType) => tagType === value);

export const isAllowedTagLang = (value: string): value is TagLang =>
  Object.values(TagLang).some((tagLang) => tagLang === value);

export const isTitleValid = (value: string) => {
  const title = value.trim();
  const alphanumericCount = title.match(/[\p{L}\p{N}]/gu)?.length ?? 0;

  return (
    title.length <= MAX_TITLE_LENGTH &&
    alphanumericCount >= MIN_ALPHANUMERIC_CHARACTERS
  );
};

export const hasBodyContent = (draft: RawDraftContentState) =>
  draft.blocks.some((block) => block.text.trim().length > 0);
